import { WidgetKeys, WidgetWrapperLevel } from 'jamespot-user-api';

import { Widget } from 'jamespot-front-business';
import { shallowEqual } from 'react-redux';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';
import { useAppSelector } from '../../../redux/store';
import styled from 'styled-components';

const WidgetIcon = commonComponentsRegistry.getLazyComponent('WidgetIcon');

export const CSSIconAbsoluteA = styled.a<{ color: string | undefined }>`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: ${(props) => (props.color ? props.color : props.theme.color.black)};
    transition: background-color 0.4s;
    &:hover {
        background-color: rgba(0, 0, 0, 0.1);
        color: ${(props) => (props.color ? props.color : props.theme.color.black)};
    }
`;

export const JRCWidgetIconWrapper = ({
    uniqid,
    name,
    url,
    level,
}: {
    uniqid: string;
    name: WidgetKeys;
    url: string;
    level: WidgetWrapperLevel;
}) => {
    const def = Widget.definition(name);
    const count = useAppSelector(
        (state) => (level === 2 ? Widget.selectors.selectWidgetChipCount(state, uniqid) : 0),
        shallowEqual,
    );
    const styles = useAppSelector((state) => Widget.selectors.selectWidgetWrapperStyle(state, uniqid), shallowEqual);

    return (
        <CSSIconAbsoluteA
            href={url}
            target="_blank"
            color={String(styles.color) ?? undefined}
            rel="noreferrer"
            aria-label={def.label}>
            <WidgetIcon count={count} img={def.img} label={def.label} maxValue={999} />
        </CSSIconAbsoluteA>
    );
};
